(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
      this.overlay = this.querySelector('#cartDrawerOverlay');
      this.closeBtn = this.querySelector('#cartDrawerClose');
      this.itemsContainer = this.querySelector('#cartDrawerItems');
      this.subtotalEl = this.querySelector('#cartDrawerSubtotal');

      this.bindEvents();
    }

    bindEvents() {
      this.closeBtn.addEventListener('click', () => this.close());
      this.overlay.addEventListener('click', () => this.close());
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') this.close();
      });
    }

    open() {
      if (window.location.pathname.startsWith('/cart') || document.body.classList.contains('template-cart')) {
        return;
      }
      this.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      this.renderCart();
    }

    close() {
      this.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    async renderCart() {
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart.js');
        const cart = await response.json();

        this.subtotalEl.textContent = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: cart.currency
        }).format(cart.total_price / 100);

        if (cart.items.length === 0) {
          this.itemsContainer.innerHTML = `
            <div class="cart-drawer__empty">
              <p class="cart-drawer__empty-text">Your cart is empty</p>
              <button class="cart-drawer__empty-continue" onclick="document.querySelector('#cartDrawer').close()">Continue Shopping</button>
            </div>
          `;
          return;
        }

        this.itemsContainer.innerHTML = cart.items.map(item => {
          let tags = '';
          if (item.product_tags) {
            const tagList = item.product_tags.split(',').map(tag => tag.trim().toLowerCase());
            if (tagList.includes('sale')) {
              tags += '<span class="cart-drawer__item-tag cart-drawer__item-tag--sale">Sale</span>';
            } else if (tagList.includes('new')) {
              tags += '<span class="cart-drawer__item-tag cart-drawer__item-tag--new">New</span>';
            } else if (tagList.includes('rare')) {
              tags += '<span class="cart-drawer__item-tag cart-drawer__item-tag--rare">Rare</span>';
            } else if (tagList.includes('limited')) {
              tags += '<span class="cart-drawer__item-tag cart-drawer__item-tag--limited">Limited</span>';
            }
          }
          if (item.compare_at_price > item.price && !tags.includes('Sale')) {
            tags += '<span class="cart-drawer__item-tag cart-drawer__item-tag--sale">Sale</span>';
          }

          return `
          <div class="cart-drawer__item" data-key="${item.key}">
            <div class="cart-drawer__item-image">
              <img src="${item.image}" alt="${item.product_title}">
            </div>
            <div class="cart-drawer__item-details">
              <div class="cart-drawer__item-header">
                <div class="cart-drawer__item-title-group">
                  <div class="cart-drawer__item-tags">${tags}</div>
                  <h3 class="cart-drawer__item-title">${item.product_title}</h3>
                  ${item.variant_title ? `<p class="cart-drawer__item-variant">${item.variant_title}</p>` : ''}
                </div>
                <p class="cart-drawer__item-price">${new Intl.NumberFormat('en-US', {
                  style: 'currency',
                  currency: cart.currency
                }).format(item.price / 100)}</p>
              </div>
              <div class="cart-drawer__item-footer">
                <div class="cart-drawer__item-quantity">
                  <button type="button" class="cart-drawer__item-qty-btn" onclick="window.updateCartItem('${item.key}', ${item.quantity - 1})">−</button>
                  <span class="cart-drawer__item-qty-value">${item.quantity}</span>
                  <button type="button" class="cart-drawer__item-qty-btn" onclick="window.updateCartItem('${item.key}', ${item.quantity + 1})">+</button>
                </div>
                <button type="button" class="cart-drawer__item-remove" onclick="window.removeCartItem('${item.key}')">Remove</button>
              </div>
            </div>
          </div>
        `;
        }).join('');
      } catch (error) {
        console.error('Error rendering cart:', error);
      }
    }
  }

  customElements.define('cart-drawer', CartDrawer);

  window.updateCartItem = async function(key, quantity) {
    if (quantity < 1) return;
    
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: key,
          quantity: quantity
        })
      });

      if (response.ok) {
        document.querySelector('#cartDrawer').renderCart();
        updateCartCount();
      }
    } catch (error) {
      console.error('Error updating cart item:', error);
    }
  };

  window.removeCartItem = async function(key) {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: key,
          quantity: 0
        })
      });

      if (response.ok) {
        document.querySelector('#cartDrawer').renderCart();
        updateCartCount();
      }
    } catch (error) {
      console.error('Error removing cart item:', error);
    }
  };

  async function updateCartCount() {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart.js');
      const cart = await response.json();
      const cartCount = document.querySelector('.site-header__cart-count');
      if (cartCount) {
        cartCount.textContent = cart.item_count;
      }
    } catch (error) {
      console.error('Error updating cart count:', error);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const quantityButtons = document.querySelectorAll('.cart-page__quantity-btn');
    const quantityInputs = document.querySelectorAll('.cart-page__quantity-input');

    quantityButtons.forEach(button => {
      button.addEventListener('click', function() {
        const action = this.dataset.action;
        const key = this.dataset.key;
        const input = document.querySelector(`.cart-page__quantity-input[data-key="${key}"]`);
        
        if (!input) return;

        let currentValue = parseInt(input.value) || 0;

        if (action === 'increase') {
          currentValue += 1;
        } else if (action === 'decrease') {
          currentValue = Math.max(0, currentValue - 1);
        }

        input.value = currentValue;

        if (currentValue === 0) {
          if (confirm('Are you sure you want to remove this item?')) {
            const form = document.querySelector('.cart-page__form');
            form.submit();
          } else {
            input.value = 1;
          }
        } else {
          const form = document.querySelector('.cart-page__form');
          form.submit();
        }
      });
    });

    quantityInputs.forEach(input => {
      input.addEventListener('change', function() {
        const value = parseInt(this.value) || 0;

        if (value === 0) {
          if (confirm('Are you sure you want to remove this item?')) {
            const form = document.querySelector('.cart-page__form');
            form.submit();
          } else {
            this.value = 1;
          }
        } else {
          const form = document.querySelector('.cart-page__form');
          form.submit();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const filterToggles = document.querySelectorAll('.collection-page__filter-toggle');

    filterToggles.forEach(toggle => {
      toggle.addEventListener('click', function() {
        const filterName = this.dataset.filter;
        const filterList = document.querySelector(`.collection-page__filter-list[data-filter="${filterName}"]`);
        const isExpanded = this.getAttribute('aria-expanded') === 'true';

        this.setAttribute('aria-expanded', !isExpanded);
        if (filterList) {
          filterList.setAttribute('aria-hidden', isExpanded);
        }
      });
    });

    const addToCartButtons = document.querySelectorAll('.collection-page__product-add[data-variant-id]');

    addToCartButtons.forEach(button => {
      button.addEventListener('click', async function() {
        const variantId = this.getAttribute('data-variant-id');
        const originalText = this.textContent;

        if (!variantId) return;

        this.textContent = 'Adding...';
        this.disabled = true;

        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [{
                id: parseInt(variantId),
                quantity: 1
              }]
            })
          });

          if (response.ok) {
            const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
            const cart = await cartResponse.json();

            const cartCount = document.querySelector('.site-header__cart-count');
            if (cartCount) {
              cartCount.textContent = cart.item_count;
            }

            const cartDrawer = document.querySelector('#cartDrawer');
            if (cartDrawer) {
              cartDrawer.open();
            }

            this.textContent = 'Added!';
            setTimeout(() => {
              this.textContent = originalText;
              this.disabled = false;
            }, 2000);
          } else {
            const error = await response.json();
            alert(error.description || 'Failed to add to cart');
            this.textContent = originalText;
            this.disabled = false;
          }
        } catch (error) {
          console.error('Error adding to cart:', error);
          alert('Failed to add to cart');
          this.textContent = originalText;
          this.disabled = false;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const addToCartButtons = document.querySelectorAll('.product-card__add[data-variant-id]');

    addToCartButtons.forEach(button => {
      button.addEventListener('click', async function() {
        const variantId = this.getAttribute('data-variant-id');
        const originalHTML = this.innerHTML;

        if (!variantId) return;

        this.textContent = 'Adding...';
        this.disabled = true;

        try {
          const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              items: [{
                id: parseInt(variantId),
                quantity: 1
              }]
            })
          });

          if (response.ok) {
            const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
            const cart = await cartResponse.json();

            const cartCount = document.querySelector('.site-header__cart-count');
            if (cartCount) {
              cartCount.textContent = cart.item_count;
            }

            const cartDrawer = document.querySelector('#cartDrawer');
            if (cartDrawer) {
              cartDrawer.open();
            }

            const qty = cart.items.reduce((sum, item) => item.id === parseInt(variantId) ? sum + item.quantity : sum, 0);

            this.classList.add('product-card__add--in-cart');
            this.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" width="14" height="14"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3.392 6.875h13.216v8.016c0 .567-.224 1.112-.624 1.513-.4.402-.941.627-1.506.627H5.522a2.13 2.13 0 0 1-1.506-.627 2.15 2.15 0 0 1-.624-1.513zM8.818 2.969h2.333c.618 0 1.211.247 1.649.686a2.35 2.35 0 0 1 .683 1.658v1.562H6.486V5.313c0-.622.246-1.218.683-1.658a2.33 2.33 0 0 1 1.65-.686" /></svg><span class="product-card__add-count">${qty}</span>`;
            this.disabled = false;
          } else {
            const error = await response.json();
            alert(error.description || 'Failed to add to cart');
            this.innerHTML = originalHTML;
            this.disabled = false;
          }
        } catch (error) {
          console.error('Error adding to cart:', error);
          alert('Failed to add to cart');
          this.innerHTML = originalHTML;
          this.disabled = false;
        }
      });
    });
  });
  document.addEventListener('DOMContentLoaded', function() {
    const sliders = document.querySelectorAll('.featured-collection__grid');

    sliders.forEach(slider => {
      const section = slider.closest('.featured-collection');
      const prev = section && section.querySelector('.featured-collection__arrow--prev');
      const next = section && section.querySelector('.featured-collection__arrow--next');
      if (!prev || !next) return;

      const getStep = () => {
        const card = slider.querySelector('.product-card');
        const gap = parseInt(window.getComputedStyle(slider).gap || 0, 10) || 0;
        return card ? card.offsetWidth + gap : 0;
      };

      const updateArrows = () => {
        prev.disabled = slider.scrollLeft <= 0;
        next.disabled = slider.scrollLeft >= slider.scrollWidth - slider.clientWidth - 1;
      };

      prev.addEventListener('click', () => {
        slider.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        slider.scrollBy({ left: getStep(), behavior: 'smooth' });
      });

      slider.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows, { passive: true });
      updateArrows();
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const tabButtons = document.querySelectorAll('.product-page__tab-button');
  const tabPanes = document.querySelectorAll('.product-page__tab-pane');

  tabButtons.forEach(button => {
    button.addEventListener('click', function() {
      const tabId = this.getAttribute('data-tab');

      // Remove active class from all buttons and panes
      tabButtons.forEach(btn => btn.classList.remove('product-page__tab-button--active'));
      tabPanes.forEach(pane => pane.classList.remove('product-page__tab-pane--active'));

      // Add active class to clicked button and corresponding pane
      this.classList.add('product-page__tab-button--active');
      const activePane = document.getElementById('tab-' + tabId);
      if (activePane) {
        activePane.classList.add('product-page__tab-pane--active');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  function changeMainImage(src, thumbnail) {
    const mainImage = document.getElementById('mainProductImage');
    if (mainImage) {
      mainImage.src = src;
    }
    document.querySelectorAll('.product-page__thumbnail').forEach(t => t.classList.remove('product-page__thumbnail--active'));
    thumbnail.classList.add('product-page__thumbnail--active');
  }

  function incrementQuantity() {
    const valueSpan = document.getElementById('quantityValue');
    const hiddenInput = document.getElementById('quantityInput');
    const currentValue = parseInt(valueSpan.textContent);
    valueSpan.textContent = currentValue + 1;
    hiddenInput.value = currentValue + 1;
    updateStickyQuantity();
  }

  function decrementQuantity() {
    const valueSpan = document.getElementById('quantityValue');
    const hiddenInput = document.getElementById('quantityInput');
    const currentValue = parseInt(valueSpan.textContent);
    if (currentValue > 1) {
      valueSpan.textContent = currentValue - 1;
      hiddenInput.value = currentValue - 1;
      updateStickyQuantity();
    }
  }

  function updateStickyQuantity() {
    const valueSpan = document.getElementById('quantityValue');
    const stickyValue = document.getElementById('stickyQuantityValue');
    if (stickyValue) {
      stickyValue.textContent = valueSpan.textContent;
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    const incrementBtn = document.getElementById('incrementBtn');
    const decrementBtn = document.getElementById('decrementBtn');
    const stickyIncrementBtn = document.getElementById('stickyIncrementBtn');
    const stickyDecrementBtn = document.getElementById('stickyDecrementBtn');
    const productForm = document.getElementById('productForm');
    const thumbnails = document.querySelectorAll('.product-page__thumbnail');

    if (incrementBtn) {
      incrementBtn.addEventListener('click', incrementQuantity);
    }

    if (decrementBtn) {
      decrementBtn.addEventListener('click', decrementQuantity);
    }

    if (stickyIncrementBtn) {
      stickyIncrementBtn.addEventListener('click', incrementQuantity);
    }

    if (stickyDecrementBtn) {
      stickyDecrementBtn.addEventListener('click', decrementQuantity);
    }

    // Listening on the form's submit event (rather than a button click) lets
    // Giftship's script run its own validation/injection first, since the
    // sticky add-to-cart button also submits this same form via requestSubmit().
    if (productForm) {
      productForm.addEventListener('submit', addToCart);
    }

    thumbnails.forEach(thumbnail => {
      thumbnail.addEventListener('click', function() {
        const imageSrc = this.getAttribute('data-image-src');
        if (imageSrc) {
          changeMainImage(imageSrc, this);
        }
      });
    });

    async function addToCart(event) {
      if (event) event.preventDefault();

      const form = document.getElementById('productForm');
      if (!form) return;

      const variantId = document.getElementById('variantSelect').value;

      if (!variantId) {
        alert('Please select a variant');
        return;
      }

      const btn = document.getElementById('addToCartBtn');
      const stickyBtn = document.querySelector('.product-page__sticky-add');
      const originalText = btn ? btn.textContent : 'Add to Cart';

      if (btn) btn.textContent = 'Adding...';
      if (stickyBtn) stickyBtn.textContent = 'Adding...';

      // Built from the live form (not a hand-rolled JSON body) so that any
      // fields apps like Giftship inject into #productForm (gift wrap option,
      // gift message, etc.) are included in the add-to-cart request.
      const formData = new FormData(form);

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (response.ok) {
          const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
          const cart = await cartResponse.json();

          const cartCount = document.querySelector('.site-header__cart-count');
          if (cartCount) {
            cartCount.textContent = cart.item_count;
          }

          // Redirect to cart page on PDP
          window.location.href = window.Shopify.routes.root + 'cart';
        } else {
          const error = await response.json();
          alert(error.description || 'Failed to add to cart');
          if (btn) btn.textContent = originalText;
          if (stickyBtn) stickyBtn.textContent = originalText;
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        alert('Failed to add to cart');
        if (btn) btn.textContent = originalText;
        if (stickyBtn) stickyBtn.textContent = originalText;
      }
    }

    // Variant option pills → sync the hidden #variantSelect (ATC source) + price
    const variantsData = document.getElementById('productVariantsData');
    const variantSelectEl = document.getElementById('variantSelect');
    if (variantsData && variantSelectEl) {
      const variants = JSON.parse(variantsData.textContent);
      const priceWrap = document.querySelector('.product-page__price');
      const moneyFmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
      const money = c => moneyFmt.format(c / 100);
      const addBtn = document.getElementById('addToCartBtn');
      const stickyBtn = document.querySelector('.product-page__sticky-add');
      const btnText = addBtn ? addBtn.textContent : 'Add to Cart';

      document.querySelectorAll('.product-page__variant-pill').forEach(pill => {
        pill.addEventListener('click', () => {
          pill.closest('.product-page__variant-pills')
            .querySelectorAll('.product-page__variant-pill')
            .forEach(p => {
              p.classList.remove('product-page__variant-pill--active');
              p.setAttribute('aria-pressed', 'false');
            });
          pill.classList.add('product-page__variant-pill--active');
          pill.setAttribute('aria-pressed', 'true');

          const selected = {};
          document.querySelectorAll('.product-page__variant-pill--active').forEach(p => {
            selected[parseInt(p.dataset.optionPosition, 10)] = p.dataset.optionValue;
          });

          const match = variants.find(v => v.options.every((o, i) => selected[i + 1] === o));
          if (!match) return;
          variantSelectEl.value = match.id;
          variantSelectEl.dispatchEvent(new Event('change', { bubbles: true }));

          if (priceWrap) {
            priceWrap.innerHTML = match.compare_at_price && match.compare_at_price > match.price
              ? '<span class="product-page__price--sale">' + money(match.price) + '</span> <span class="product-page__price--original">' + money(match.compare_at_price) + '</span>'
              : '<span>' + money(match.price) + '</span>';
          }
          [addBtn, stickyBtn].forEach(b => {
            if (!b) return;
            b.disabled = !match.available;
            b.textContent = match.available ? btnText : 'Sold Out';
          });
        });
      });
    }

    const tabButtons = document.querySelectorAll('.product-page__tab-button');
    const tabPanes = document.querySelectorAll('.product-page__tab-pane');

    tabButtons.forEach(button => {
      button.addEventListener('click', function() {
        const tabId = this.getAttribute('data-tab');

        tabButtons.forEach(btn => btn.classList.remove('product-page__tab-button--active'));
        this.classList.add('product-page__tab-button--active');

        tabPanes.forEach(pane => pane.classList.remove('product-page__tab-pane--active'));
        document.getElementById('tab-' + tabId).classList.add('product-page__tab-pane--active');
      });
    });

    const stickyBar = document.getElementById('pdpStickyBar');
    if (stickyBar) {
      window.addEventListener('scroll', function() {
        if (window.scrollY > 600) {
          stickyBar.classList.add('product-page__sticky-bar--visible');
        } else {
          stickyBar.classList.remove('product-page__sticky-bar--visible');
        }
      });
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const RECENTLY_VIEWED_KEY = 'pdp_recently_viewed';

    document.querySelectorAll('[id^="pdpRecentlyViewed-"]').forEach(function(recentGrid) {
      const currentHandle = recentGrid.getAttribute('data-current-handle');
      const limit = parseInt(recentGrid.getAttribute('data-limit'), 10) || 6;
      let viewed = [];

      try {
        viewed = JSON.parse(localStorage.getItem(RECENTLY_VIEWED_KEY)) || [];
      } catch (e) {
        viewed = [];
      }

      viewed = viewed.filter(function(h) { return h !== currentHandle; });
      const toRender = viewed.slice(0, limit);

      if (currentHandle) {
        viewed.unshift(currentHandle);
        viewed = viewed.filter(function(h, i) { return viewed.indexOf(h) === i; }).slice(0, 12);
        localStorage.setItem(RECENTLY_VIEWED_KEY, JSON.stringify(viewed));
      }

      const section = recentGrid.closest('section');

      if (toRender.length) {
        if (section) section.style.display = '';
        toRender.forEach(function(handle) {
          fetch('/products/' + handle + '.js')
            .then(function(res) { return res.ok ? res.json() : null; })
            .then(function(p) {
              if (!p) return;
              const card = document.createElement('a');
              card.href = p.url;
              card.className = 'product-page__product-card';
              card.innerHTML =
                '<div class="product-page__product-image-wrapper">' +
                  (p.featured_image ? '<img src="' + p.featured_image.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_500x500.$1') + '" alt="' + p.title + '" class="product-page__product-image" loading="lazy">' : '') +
                '</div>' +
                '<div class="product-page__product-info">' +
                  '<div class="product-page__product-brand">' + (p.vendor || '') + '</div>' +
                  '<h3 class="product-page__product-title">' + p.title + '</h3>' +
                  '<div class="product-page__product-footer">' +
                    '<div class="product-page__product-price">' + (p.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) + '</div>' +
                    '<button type="button" class="product-page__product-add">Add</button>' +
                  '</div>' +
                '</div>';
              recentGrid.appendChild(card);
            })
            .catch(function() {});
        });
      } else if (section) {
        section.style.display = 'none';
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
